import { Flex, IconButton, useColorMode } from '@chakra-ui/core';
import { useObserver } from 'mobx-react';
import React from 'react';
import { MdPause, MdPlayArrow, MdSkipNext } from 'react-icons/md';

import { useStores } from '../hooks/useStores';

function useStoreData() {
    const { store } = useStores();
    return useObserver(() => ({
        pause: store.playback.pause,
        resume: store.playback.resume,
        playNext: store.playback.getNextTrack,
        isThereNext: store.playback.queue.length > 1,
        isPlaying: store.playback.config.isPlaying,
    }));
}

const PlayerControls = () => {
    const { pause, resume, playNext, isThereNext, isPlaying } = useStoreData();
    const { colorMode } = useColorMode();
    const color = { light: 'gray.900', dark: 'gray.100' };

    return (
        <Flex alignItems="center" justifyContent="center">
            {isPlaying ? (
                <IconButton fontSize="30px" size="lg" aria-label="Pause" variant="ghost" icon={MdPause} onClick={pause} />
            ) : (
                <IconButton fontSize="30px" size="lg" aria-label="Play" variant="ghost" icon={MdPlayArrow} onClick={resume} />
            )}
            {isThereNext && (
                <IconButton
                    size="lg"
                    fontSize="30px"
                    aria-label="Next"
                    variant="ghost"
                    icon={MdSkipNext}
                    onClick={() => playNext()}
                />
            )}
        </Flex>
    );
};

export default PlayerControls;
